import { LinearProgress } from "@mui/material";

export function Loading() {
    return <LinearProgress />
}